// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var MimeType = function (x) {
    return x;
};
var tsBridgeMimeType = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("MimeType")("__brandMimeType"));
    }
};
var writeMimeType = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showMimeType = Data_Show.showString;
var readMimeType = Simple_JSON.readString;
var ordMimeType = Data_Ord.ordString;
var newtypeMimeType = {
    Coercible0: function () {
        return undefined;
    }
};
var makeMimeType = MimeType;
var eqMimeType = Data_Eq.eqString;
export {
    MimeType,
    makeMimeType,
    unwrap,
    newtypeMimeType,
    eqMimeType,
    ordMimeType,
    showMimeType,
    readMimeType,
    writeMimeType,
    tsBridgeMimeType
};
//# sourceMappingURL=index.js.map
